import { Card } from './ui/card';
import s from '../styles/modules/FilialInfo.module.scss';
import { Building2, AlertCircle } from 'lucide-react';
import Markdown from 'react-markdown';
import { useClubInfo } from '../hooks/useClubInfo';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import { useHome } from '../hooks/useHome';

const ClubInfo = () => {
  const { data, isLoading } = useClubInfo();
  const { selectedClubValue, updateDataFilial, setSelectedClubValue } = useHome();

  return (
    <Card className="mt-6 shadow-sm transition-all duration-200 hover:border-primary hover:shadow-md">
      <div className="flex flex-col justify-start items-start pl-6 pr-6 pt-6 md:flex-row md:justify-between md:items-center gap-4">
        <div className="flex items-center gap-4 ">
          <div className="rounded-lg bg-primary/10 p-3 text-primary">
            <Building2 className="h-6 w-6" />
          </div>
          <h2 className="text-xl font-medium text-gray-900">Информация о филиале</h2>
        </div>
        <div className="flex items-center justify-end gap-4">
          <span className="text-base text-gray-600 pl-2">Филиал:</span>
          <Select
            value={selectedClubValue}
            onValueChange={(value) => {
              const clubs = JSON.parse(localStorage.getItem('clubs') || '[]');
              const selectedClub = clubs.find((club) => club.title === value);
              if (selectedClub) {
                updateDataFilial(selectedClub.title, selectedClub.id);
                setSelectedClubValue(value);
                localStorage.setItem('club_name', value);
              }
            }}>
            <SelectTrigger className="w-[180px] text-base">
              <SelectValue placeholder="Выберите филиал" />
            </SelectTrigger>
            <SelectContent className="text-base max-h-[200px]">
              {localStorage.getItem('email') &&
              localStorage.getItem('email').slice(-12) === '@akvastar.ru'
                ? JSON.parse(localStorage.getItem('clubs') || '[]').map(({ title, id }, i) => (
                    <SelectItem key={i} value={title} className="text-base">
                      {title}
                    </SelectItem>
                  ))
                : JSON.parse(localStorage.getItem('clubs') || '[]')
                    .filter((club) => club.id !== '246e5cc0-ae65-11ef-9106-2a618cb265e1')
                    .map(({ title, id }, i) => (
                      <SelectItem key={i} value={title} className="text-base">
                        {title}
                      </SelectItem>
                    ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      {isLoading ? (
        <div className="flex items-center justify-center p-8 text-gray-400">
          <div className="flex items-center gap-2">
            <div className="h-5 w-5 animate-spin rounded-full border-b-2 border-primary"></div>
            <span>Загрузка...</span>
          </div>
        </div>
      ) : data ? (
        <div className={s.text_info}>
          <div className="p-6">
            <Markdown>{data}</Markdown>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center p-8">
          <div className="flex items-center gap-3 rounded-lg bg-gray-50 p-4 text-gray-500">
            <AlertCircle className="h-5 w-5 text-gray-400" />
            <span className="text-sm">Информация о филиале недоступна</span>
          </div>
        </div>
      )}
    </Card>
  );
};

export default ClubInfo;
